export default "/assets/images/Suzzne-cat.b17dede750c4f53f.jpg";